import checkout from "./form4";

const {
  formField4: {
    taxpayers,
    taxCode,

    supportData,
  },
} = checkout;

const initialValues4 = {
  [taxpayers.name]: "",
  [taxCode.name]: "",

  [supportData.name]: false,
};

export default initialValues4;
